/* Pretty Willow — Black Friday 2026 CRO layer (countdown, tiers, quick add, menu, sticky ATC) */
(function () {
  var FINAL = Date.UTC(2026, 10, 30, 23, 59, 59); // Cyber Monday 30 Nov, 23:59 UK (GMT)

  /* ---------- Countdown: today's prices end at midnight UK, last 3 days count to the final deadline ---------- */
  function londonMidnight(now) {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date(now));
    var get = function (t) { return +parts.find(function (p) { return p.type === t; }).value; };
    var secsIntoDay = get('hour') * 3600 + get('minute') * 60 + get('second');
    return now + (86400 - secsIntoDay) * 1000;
  }
  function target() {
    var now = Date.now();
    if (now >= FINAL) return 0;
    return Math.min(londonMidnight(now), FINAL);
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var t = target(), left = Math.max(0, t - Date.now());
    var h = Math.floor(left / 3600000), m = Math.floor(left % 3600000 / 60000), s = Math.floor(left % 60000 / 1000);
    document.querySelectorAll('[data-pw-cd]').forEach(function (el) {
      if (!t) { el.closest('[data-pw-cd-wrap]') && (el.closest('[data-pw-cd-wrap]').style.display = 'none'); return; }
      el.innerHTML = '<span>' + pad(h) + '</span>:<span>' + pad(m) + '</span>:<span>' + pad(s) + '</span>';
    });
    document.querySelectorAll('[data-pw-cd-label]').forEach(function (el) {
      el.textContent = (FINAL - Date.now() < 3 * 86400000) ? el.dataset.final || 'Black Friday ends in' : el.dataset.daily || "Today's prices end in";
    });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- Tier bars (client side refresh after any cart change) ---------- */
  /* Offer: 3 for 2 on everything (cheapest free, repeats every 3), 2 pieces = -10% as the first step. */
  function tierHTML(count) {
    var inSet = count % 3, free = Math.floor(count / 3), msg;
    if (count === 0) msg = 'Black Friday: <b>buy any 3, the cheapest is FREE</b>.';
    else if (count === 1) msg = 'Add <b>2 more pieces</b> and one of them is <b>FREE</b> (or 1 more for 10% off).';
    else if (count === 2) msg = 'You have 10% off. Add <b>1 more piece</b> and the cheapest one is <b>FREE</b>!';
    else if (inSet === 0) msg = '<b>' + free + ' piece' + (free > 1 ? 's are' : ' is') + ' FREE</b> in your bag. Add 3 more to get another one free.';
    else msg = '<b>' + free + ' FREE</b> in your bag. Add <b>' + (3 - inSet) + ' more</b> to get ' + (free + 1) + ' free.';
    var stepCount = count >= 3 ? 3 : count;
    var pct = count >= 3 ? 100 : (count / 3) * 100;
    var steps = ['1 piece', '2 · -10%', '3 · 1 FREE'].map(function (l, i) { return '<div class="' + (stepCount >= i + 1 && i > 0 ? 'is-on' : '') + '">' + l + '</div>'; }).join('');
    return '<div class="pw-tiers__msg">' + msg + '</div><div class="pw-tiers__track"><div class="pw-tiers__fill" style="width:' + pct + '%"></div></div><div class="pw-tiers__steps" style="grid-template-columns:repeat(3,1fr)">' + steps + '</div>';
  }
  function refreshTiers(cart) {
    readCart(cart);
    document.querySelectorAll('[data-pw-tiers]').forEach(function (el) {
      var extra = +(el.dataset.extra || 0);
      el.innerHTML = tierHTML(cart.item_count + extra);
    });
    document.querySelectorAll('[data-pw-count]').forEach(function (el) { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
  }
  function loadCart() { return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }); }
  document.addEventListener('cart:change', function (e) { if (e.detail && e.detail.cart) refreshTiers(e.detail.cart); else loadCart().then(refreshTiers); });
  document.addEventListener('cart:refresh', function () { setTimeout(function () { loadCart().then(refreshTiers); }, 400); });
  loadCart().then(refreshTiers);

  /* ---------- Toast + open drawer ---------- */
  function toast(text) {
    var t = document.querySelector('.pw-toast');
    if (!t) { t = document.createElement('div'); t.className = 'pw-toast'; document.body.appendChild(t); }
    t.textContent = text; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }
  function openDrawer() {
    var d = document.getElementById('cart-drawer');
    if (d && typeof d.show === 'function') { d.show(); } else { location.href = '/cart'; }
  }
  window.PW = { toast: toast, openDrawer: openDrawer, loadCart: loadCart };

  /* ---------- Visitor profile (this device only) ----------
     What she views and for how long, the looks she watches, likes and opens, and what is in her bag.
     Shared with the Shop the look feed (localStorage pwl_aff / pwl_cart) and used to rank every recommendation rail. */
  var KEYS = ['dress', 'maxi', 'mini', 'hoodie', 'knit', 'sweater', 'jumper', 'mohair', 'cardigan', 'jean', 'trouser', 'skirt', 'boot', 'shoe', 'coat', 'jacket', 'trench', 'set', 'robe', 'slip', 'necklace', 'choker', 'ring', 'pendant', 'bracelet', 'top', 'blouse', 'shirt'];
  var LS = {
    get: function (k, d) { try { var v = localStorage.getItem('pwl_' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem('pwl_' + k, JSON.stringify(v)); } catch (e) {} }
  };
  function typesOf(s) { s = (s || '').toLowerCase(); return KEYS.filter(function (k) { return s.indexOf(k) > -1; }); }
  function affNow() { var a = LS.get('aff', {}); a.vibe = a.vibe || {}; a.type = a.type || {}; a.pid = a.pid || {}; return a; }
  function learn(pid, types, w) {
    var a = affNow();
    if (pid) a.pid[pid] = (a.pid[pid] || 0) + w;
    typesOf(types).forEach(function (k) { a.type[k] = (a.type[k] || 0) + w; });
    LS.set('aff', a);
  }
  var inCart = LS.get('cart', []), cartTypes = LS.get('cart_types', []);
  var pdp = document.querySelector('[data-pw-product][data-pid]');
  var curPid = pdp ? pdp.dataset.pid : '', curTypes = pdp ? typesOf(pdp.dataset.types) : [];

  function readCart(cart) {
    if (!cart || !cart.items) return;
    var ids = [], types = [], known = LS.get('carted', {});
    cart.items.forEach(function (i) {
      var id = String(i.product_id), t = i.product_type + ' ' + i.product_title;
      ids.push(id); types = types.concat(typesOf(t));
      if (!known[id]) { known[id] = 1; learn(id, t, 6); }
    });
    var changed = ids.join() !== inCart.join();
    inCart = ids; cartTypes = types;
    LS.set('cart', ids); LS.set('cart_types', types); LS.set('carted', known);
    if (changed) rankAll();
  }

  /* related: more of what she likes. complementary: what finishes her outfit (types she already has drop down). looks: vibe + pieces + bag. */
  function score(el, mode, a) {
    var t = typesOf(el.dataset.types), s = 0;
    if (mode === 'looks') {
      s = (a.vibe[el.dataset.vibe] || 0) * 1.2;
      t.forEach(function (k) { s += a.type[k] || 0; });
      (el.dataset.pids || '').split(',').forEach(function (id) { if (!id) return; s += (a.pid[id] || 0) * .5; if (inCart.indexOf(id) > -1) s += 8; });
      return el.dataset.mine ? s + 1e4 : s;
    }
    if (inCart.indexOf(el.dataset.pid) > -1 || el.dataset.pid === curPid) return -1e6;
    t.forEach(function (k) {
      var v = a.type[k] || 0;
      if (mode === 'complementary') s += (cartTypes.indexOf(k) > -1 || curTypes.indexOf(k) > -1) ? -v * .5 : v * .6;
      else s += v;
    });
    if (mode === 'related' && t.some(function (k) { return curTypes.indexOf(k) > -1; })) s += 4;
    return s + (a.pid[el.dataset.pid] || 0) * .3;
  }
  function rank(box) {
    var mode = box.dataset.pwRank || box.dataset.mode || 'related', a = affNow();
    var kids = [].slice.call(box.children).filter(function (c) { return c.dataset.pid || c.dataset.pids != null; });
    if (kids.length < 2) return;
    var anchor = kids[kids.length - 1].nextSibling;
    kids.forEach(function (c, i) { c._pws = score(c, mode, a) - i * .01; });
    kids.sort(function (x, y) { return y._pws - x._pws; }).forEach(function (c) { box.insertBefore(c, anchor); });
    if (mode !== 'looks') {
      var keep = kids.filter(function (c) { return c._pws > -1e5; }).length;
      kids.forEach(function (c) { c.style.display = (c._pws <= -1e5 && keep >= 2) ? 'none' : ''; });
    }
  }
  function rankAll() { document.querySelectorAll('[data-pw-rank],[data-pw-recos][data-loaded]').forEach(function (b) { if (!b.dataset.touched) rank(b); }); }
  /* Never reshuffle a rail she has started to swipe */
  ['pointerdown', 'wheel'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { var t = e.target.closest && e.target.closest('[data-pw-rank],[data-pw-recos]'); if (t) t.dataset.touched = 1; }, { capture: true, passive: true });
  });

  /* "You may also like": blend in what goes with the piece she lingered on most */
  function topViewed() {
    var a = affNow();
    return Object.keys(a.pid).filter(function (id) { return id !== curPid && inCart.indexOf(id) < 0 && a.pid[id] >= 3; })
      .sort(function (x, y) { return a.pid[y] - a.pid[x]; })[0];
  }
  function blend(el) {
    var id = el.dataset.blend && topViewed(); if (!id) return;
    fetch(el.dataset.blend + id).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'), have = {}, added = 0; tmp.innerHTML = html;
      el.querySelectorAll('[data-pid]').forEach(function (m) { have[m.dataset.pid] = 1; });
      [].slice.call(tmp.querySelectorAll('[data-pw-recos-inner] > .pw-mini')).forEach(function (m) {
        if (added < 4 && !have[m.dataset.pid] && m.dataset.pid !== curPid) { el.appendChild(m); added++; }
      });
      if (!added) return;
      if (!el.dataset.touched) rank(el);
      var sub = el.closest('.pw-recos') && el.closest('.pw-recos').querySelector('.pw-recos__head p');
      if (sub) sub.textContent = 'Picked for you from what you’ve been browsing. Same 3 for 2 deal.';
    }).catch(function () {});
  }

  /* Product page: a view counts a little, time spent on it counts more */
  if (pdp) {
    learn(curPid, pdp.dataset.types, 1);
    var since = Date.now(), dwell = 0;
    var flush = function () {
      if (since) { dwell += Date.now() - since; since = 0; }
      if (dwell > 8000) learn(curPid, pdp.dataset.types, Math.min(6, dwell / 15000));
      dwell = 0;
    };
    document.addEventListener('visibilitychange', function () { if (document.hidden) flush(); else since = Date.now(); });
    window.addEventListener('pagehide', flush);
  }
  rankAll();
  window.PW.profile = { aff: affNow, learn: learn, rank: rank };

  /* ---------- Quick add (recos / upsell / complete the look) ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-pw-quickadd]');
    if (!f) return;
    e.preventDefault();
    var btn = f.querySelector('button'); var id = f.querySelector('[name=id]').value;
    if (!id) { toast('Choose your size first'); return; }
    btn.disabled = true; var old = btn.textContent; btn.textContent = '…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        toast('Added to your bag');
        if (!f.closest('cart-drawer')) setTimeout(openDrawer, 350);
      })
      .catch(function (err) { btn.textContent = old; toast((err && err.description) || 'Sorry, this size just sold out'); })
      .finally(function () { setTimeout(function () { btn.disabled = false; if (btn.textContent === 'Added ✓') btn.textContent = old; }, 1600); });
  });

  /* ---------- Lazy section loaders (product recommendations) ---------- */
  function loadRecos(el) {
    if (el.dataset.loaded) return; el.dataset.loaded = 1;
    fetch(el.dataset.url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-pw-recos-inner]');
      if (inner && inner.querySelector('.pw-mini')) { el.innerHTML = inner.innerHTML; el.hidden = false; rank(el); blend(el); }
      else if (el.dataset.fallback) { el.dataset.url = el.dataset.fallback; el.dataset.fallback = ''; el.dataset.loaded = ''; loadRecos(el); }
      else { el.remove(); }
    }).catch(function () { el.remove(); });
  }
  function scanRecos(root) {
    (root || document).querySelectorAll('[data-pw-recos]').forEach(function (el) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); loadRecos(el); } }, { rootMargin: '600px' });
        io.observe(el.parentElement || el);
      } else loadRecos(el);
    });
  }
  scanRecos();
  /* Sections (cart drawer, quick views) re-render after cart changes: pick up any new placeholder */
  var scanTimer;
  new MutationObserver(function () {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(function () {
      document.querySelectorAll('[data-pw-recos]:not([data-loaded])').forEach(function (el) {
        if (el.closest('cart-drawer')) loadRecos(el); else scanRecos(el.parentElement);
      });
    }, 250);
  }).observe(document.body, { childList: true, subtree: true });

  /* ---------- Shop a look from a rail (home + product page): one piece or the full look ---------- */
  var lsSheet = null, lsBody, lsFoot, lsTitle;
  function lsEnsure() {
    if (lsSheet) return;
    lsSheet = document.createElement('div'); lsSheet.className = 'pw pwls-sheet';
    lsSheet.innerHTML = '<div class="pwls-sheet__bg" data-pwls-close></div><div class="pwls-sheet__p" role="dialog" aria-modal="true"><div class="pwls-sheet__head"><b></b><button type="button" data-pwls-close aria-label="Close">×</button></div><div class="pwls-sheet__body"></div><div class="pwls-sheet__foot"></div></div>';
    document.body.appendChild(lsSheet);
    lsBody = lsSheet.querySelector('.pwls-sheet__body'); lsFoot = lsSheet.querySelector('.pwls-sheet__foot'); lsTitle = lsSheet.querySelector('.pwls-sheet__head b');
    lsSheet.addEventListener('click', lsClick);
  }
  function lsClose() { lsSheet.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  function lsAdd(items, btn, msg) {
    btn.disabled = true; var old = btn.textContent; btn.textContent = 'Adding…';
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); toast(msg); lsClose(); setTimeout(openDrawer, 350); })
      .catch(function (err) { toast((err && err.description) || 'That size just sold out, please pick another'); })
      .finally(function () { btn.disabled = false; btn.textContent = old; });
  }
  function lsClick(e) {
    if (e.target.closest('[data-pwls-close]')) return lsClose();
    var one = e.target.closest('[data-pwl-one]');
    if (one) {
      var v = one.closest('.pwl-row').querySelector('[data-pwl-variant]');
      if (!v.value) { v.classList.add('err'); toast('Choose your size first'); return; }
      return lsAdd([{ id: +v.value, quantity: 1 }], one, 'Added to your bag');
    }
    var all = e.target.closest('[data-pwl-add]');
    if (all) {
      var items = [], missing = false;
      lsBody.querySelectorAll('.pwl-row').forEach(function (r) {
        if (!r.querySelector('[data-pwl-include]').checked) return;
        var s = r.querySelector('[data-pwl-variant]');
        if (!s.value) { missing = true; s.classList.add('err'); return; }
        items.push({ id: +s.value, quantity: 1 });
      });
      if (missing) return toast('Choose your sizes first');
      if (items.length) lsAdd(items, all, 'Look added to your bag');
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-pwls-open]'); if (!b) return;
    e.preventDefault();
    var tpl = b.closest('[data-pwls]').querySelector('[data-pwls-tpl]');
    lsEnsure();
    var frag = tpl.content.cloneNode(true);
    lsBody.innerHTML = ''; lsFoot.innerHTML = '';
    lsFoot.appendChild(frag.querySelector('[data-pwls-foot]')); lsBody.appendChild(frag);
    lsTitle.textContent = tpl.dataset.title || 'Shop the look';
    var f = b.dataset.pwlsOpen;
    if (f !== undefined && f !== '') { var row = lsBody.querySelector('[data-row="' + f + '"]'); if (row) { row.classList.add('is-focus'); setTimeout(function () { row.scrollIntoView({ block: 'nearest' }); }, 320); } }
    lsSheet.classList.add('is-open'); document.documentElement.style.overflow = 'hidden';
  });

  /* ---------- Menu drawer ---------- */
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-pw-menu-open]'), c = e.target.closest('[data-pw-menu-close]');
    var m = document.querySelector('.pw-menu');
    if (!m) return;
    if (o) { m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; }
    if (c) { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; }
  });
})();
